// removed by extract-text-webpack-plugin
module.exports = {"container":"guest-list-row-container__container__26FL_","guest-body":"guest-list-row-container__guest-body__3RX3a","message-icon":"guest-list-row-container__message-icon__1eq0f","message-icon-active":"guest-list-row-container__message-icon-active__2YYLO guest-list-row-container__message-icon__1eq0f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/guest_list/guest-list-row-container.scss
// module id = 1407
// module chunks = 1